var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtaskicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0942 9.22632C20.0541 9.22632 21.6414 7.63896 21.6414 5.67915V3.90557C21.6414 1.94576 20.0541 0.358398 18.0942 0.358398H3.90557C1.94576 0.358398 0.358398 1.94576 0.358398 3.90557V5.67915C0.358398 7.63896 1.94576 9.22632 3.90557 9.22632V13.6603C3.90557 16.1078 5.89198 18.0942 8.33953 18.0942H9.22632C9.22632 20.0541 10.8137 21.6414 12.7735 21.6414H18.0942C20.0541 21.6414 21.6414 20.0541 21.6414 18.0942V16.3207C21.6414 14.3609 20.0541 12.7735 18.0942 12.7735H12.7735C10.8137 12.7735 9.22632 14.3609 9.22632 16.3207H8.33953C6.87632 16.3207 5.67915 15.1235 5.67915 13.6603V9.22632H18.0942ZM10.9999 16.3207C10.9999 15.3452 11.798 14.5471 12.7735 14.5471H18.0942C19.0697 14.5471 19.8678 15.3452 19.8678 16.3207V18.0942C19.8678 19.0697 19.0697 19.8678 18.0942 19.8678H12.7735C11.798 19.8678 10.9999 19.0697 10.9999 18.0942V16.3207ZM2.13198 5.67915V3.90557C2.13198 2.9301 2.9301 2.13198 3.90557 2.13198H18.0942C19.0697 2.13198 19.8678 2.9301 19.8678 3.90557V5.67915C19.8678 6.65462 19.0697 7.45274 18.0942 7.45274H3.90557C2.9301 7.45274 2.13198 6.65462 2.13198 5.67915Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtaskicon);
export default __webpack_public_path__ + "static/media/Subtaskicon.9b6ae5152696d4e4565ec86a9c351759.svg";
export { ForwardRef as ReactComponent };